(function () {
  'use strict';

  /* ================================================================
     NewPharma — barra de progreso hacia el ENVIO GRATIS

     Reemplaza a gift-progress-bar.js, que marcaba cuanto faltaba para
     el Shiitake de regalo. Misma mecanica probada -mismo punto de
     insercion, misma deteccion de cambios del carrito-, otro objetivo.

     El archivo viejo queda en assets/ sin cargarse, por si la promo del
     regalo vuelve. Su CSS es el bloque 25 de custom.css; el de esta
     barra es el 53.
     ================================================================ */

  // ===== CONFIG =====
  var THRESHOLD   = 2999000;              // $29.990 en centavos
  var REGIONES    = 'regiones IV, V, VI y RM';
  var GIFT_VARIANT_ID = 49431776133358;   // el Shiitake de regalo, si sigue activo
  // ==================

  var busy = false, debounce = null;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Formato moneda CLP: $29.990
  function formatCLP(cents) {
    var pesos = Math.round(cents / 100);
    return '$' + pesos.toLocaleString('es-CL');
  }

  function buildBar() {
    var wrap = document.createElement('div');
    wrap.className = 'ship-progress';
    wrap.setAttribute('data-ship-progress', '');
    wrap.innerHTML =
      '<div class="ship-progress__msg" data-sp-msg></div>' +
      '<div class="ship-progress__track">' +
        '<div class="ship-progress__fill" data-sp-fill></div>' +
        '<div class="ship-progress__icon" data-sp-icon>🚚</div>' +
      '</div>';
    return wrap;
  }

  // Misma cadena de selectores que usaba la barra del regalo: son los
  // contenedores reales del drawer de este tema, en orden de preferencia.
  function ensureBarPlaced() {
    var ya = document.querySelector('[data-ship-progress]');
    if (ya) return ya;

    var host =
      document.querySelector('[data-cart-dynamic-content="cart-body"]') ||
      document.querySelector('.cart-drawer__body') ||
      document.querySelector('.global-drawer__body--content') ||
      document.querySelector('.global-drawer__body') ||
      document.querySelector('.global-drawer__content') ||
      document.querySelector('cart-drawer form[action*="/cart"]') ||
      document.querySelector('form[action*="/cart"]');

    if (!host) return null;

    var bar = buildBar();
    host.insertBefore(bar, host.firstChild);
    return bar;
  }

  function update() {
    if (busy) return;
    busy = true;

    getCart().then(function (cart) {
      // El regalo a $0 no suma, pero se excluye igual: si alguna vez se
      // le pone precio, el umbral no se alcanzaria con un producto que
      // el cliente no eligio.
      var subtotal = 0;
      cart.items.forEach(function (item) {
        if (item.variant_id !== GIFT_VARIANT_ID) {
          subtotal += item.final_line_price;
        }
      });

      var bar = ensureBarPlaced();
      if (!bar) { busy = false; return; }

      var msg  = bar.querySelector('[data-sp-msg]');
      var fill = bar.querySelector('[data-sp-fill]');
      var icon = bar.querySelector('[data-sp-icon]');

      // LA BARRA NO PUEDE VERSE LLENA SI EL ENVIO NO ES GRATIS TODAVIA.
      //
      // Se usa `floor` con tope en 99 mientras no califique, no `round`:
      // redondeando, un carrito de $29.900 mostraria 100% sin tener el
      // beneficio. Es el mismo error que hubo con la barra del regalo en
      // septiembre, cuando dos unidades de $19.990 daban $39.980 y la
      // barra llegaba al tope $10 antes de tiempo.
      var pct = subtotal >= THRESHOLD
        ? 100
        : Math.min(99, Math.floor((subtotal / THRESHOLD) * 100));
      fill.style.width = pct + '%';

      if (subtotal >= THRESHOLD) {
        msg.innerHTML = '🎉 ¡Tienes <strong>envío gratis</strong> a ' + REGIONES + '!';
        bar.classList.add('is-complete');
        icon.textContent = '✅';
      } else {
        var falta = THRESHOLD - subtotal;
        msg.innerHTML =
          'Te faltan <strong>' + formatCLP(falta) + '</strong> para envío gratis' +
          '<span class="ship-progress__sub">a ' + REGIONES + '</span>';
        bar.classList.remove('is-complete');
        icon.textContent = '🚚';
      }

      busy = false;
    }).catch(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(update, 400);
  }

  // Detecta cambios del carrito interceptando las llamadas, igual patron
  // que free-gift.js. Se ignora /cart.js para no re-disparar con la
  // consulta que hace esta misma barra.
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = _fetch.apply(this, arguments);
    if (url.indexOf('/cart.js') === -1 && CART_RE.test(url)) p.then(schedule, function () {});
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_RE.test(url)) {
      this.addEventListener('load', schedule);
    }
    return _open.apply(this, arguments);
  };

  // El drawer se dibuja y se redibuja solo; sin esto la barra aparece
  // recien despues de la primera accion del cliente.
  function watchDrawer() {
    new MutationObserver(function () {
      if (document.querySelector('cart-drawer, .global-drawer, [data-cart-dynamic-content="cart-body"], form[action*="/cart"]')) {
        schedule();
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  document.addEventListener('DOMContentLoaded', function () {
    update();
    watchDrawer();
  });

  document.addEventListener('cart:refresh', schedule);
})();
